<div [formGroup]="form" class="ovrrride-flange-input-wrap">
    <mat-label class="font-style" [ngbTooltip]="recommendedGasketStress_tooltip" placement="right" container="body" tooltipClass="custom-tooltip">
        <!-- Rec Gasket Stress -->
        {{ 'CUSTOM_FLANGE_PAGE.LABELS.CALC_INPUT.REC_GASKET_STRESS' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #recommendedGasketStress_tooltip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.REC_GASKET_STRESS' | transloco }}
        </p>
    </ng-template>
    <!--tool-tip template end-->

    <div class="example-checkbox" [ngClass]="form.get('recGasketStress').valid ? '' : 'highLight'">
        <div>
            <mat-checkbox class="example-margin checkbox-wrap" name="resultOptionEl" formControlName="isRecGasketStress"></mat-checkbox>
        </div>
        <mat-form-field class="example-full-width" [floatLabel]="'never'">
            <input matInput formControlName="recGasketStress" name="recGasketStress" [readonly]="!form.get('isRecGasketStress').value" />
        </mat-form-field>
    </div>
</div>
